import { restApi } from '@icp/settings';
import * as cache from './extensionCache';

const DMRA_ERROR = () =>
  Promise.reject(
    Error(
      'Rest Api in form designer is not available. Provide a named export `mockRestApi` to mock rest api in form designer',
    ),
  );
const DefaultMockRestApi = {
  get: DMRA_ERROR,
  put: DMRA_ERROR,
  post: DMRA_ERROR,
  delete: DMRA_ERROR,
};

export default class RemoteCommonInstance {
  #module = null;

  #handle = null;

  async load({ jsUrl, manualLoad }) {
    await Promise.resolve()
      .then(async () => {
        if (!manualLoad) return jsUrl;
        let jsText = await cache.getCache(jsUrl);
        if (!jsText) {
          jsText = await restApi.get(jsUrl, { responseType: 'text', noTimestamp: true });
          cache.setCache(jsUrl, jsText);
        }
        return `data:text/javascript,${encodeURIComponent(jsText)}`;
      })
      .then((url) => import(/* webpackIgnore: true */ url))
      .then((module) => {
        this.#module = module;
      });
  }

  async mount(...args) {
    await Promise.resolve(this.#module)
      .then((module) => module.default(...args))
      .then((handle) => {
        this.#handle = handle;
      });
  }

  async unmount() {
    await Promise.resolve(this.#handle)
      .then((handle) => {
        // 简易方式
        if (typeof handle === 'function') return handle;
        // 复杂方式
        if (typeof handle?.unmount === 'function') return handle.unmount;
        return null;
      })
      .then((unmountFn) => unmountFn?.());
  }

  updateValue(value) {
    this.#handle?.updateValue?.(value);
  }

  updateParams(params) {
    this.#handle?.updateParams?.(params);
  }

  get validator() {
    return this.#handle?.validate;
  }

  get mockRestApi() {
    return this.#handle?.mockRestApi ?? DefaultMockRestApi;
  }

  get schema() {
    return this.#module?.schema;
  }
}
